import Translations from '../Translations';
import React, {
    useState,
} from 'react';
import {
    Modal,
    Button,
    Icon,
    // Loader,
} from 'semantic-ui-react';
import {
    Document,
    Page
} from 'react-pdf/dist/esm/entry.webpack';
import {
    SizeMe,
} from 'react-sizeme';

const ModalViewDocument = (props) => {

    const {
        document,
    } = props;

    // console.log('document->', document);

    const [open, setOpen] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    // const [pageNumber, setPageNumber] = useState(1);
    const [zoomScale, setZoomScale] = useState(1);

    return (
        <Modal
            size="fullscreen"
            open={open}
            dimmer="inverted"
            closeIcon={<Translations text="common.close" backup="Close" render={label => <Icon name="close" aria-label={label} onClick={() => setOpen(false)} />} />}
            closeOnTriggerClick
            trigger={(
                <Translations text="selection.Product Summary" backup="Product Summary" render={label => <Icon
                    aria-label={label}
                    name="info circle"
                    color="blue"
                    onClick={() => setOpen(true)}
                />} />
            )}
            onClose={() => setOpen(false)}
        >
            <Modal.Header><Translations text="selection.Product Summary" backup={"Product Summary"} /></Modal.Header>
            <Modal.Content scrolling>
                <SizeMe
                    monitorHeight={false}
                >
                    {({ size, }) => (
                        <Document
                            // loading={<Loader>Loading</Loader>}
                            loading={<Translations text="common.loading" backup="Loading" />}
                            error={<Translations text="selection.document_load_error" backup="Failed to load PDF file." />}
                            noData={<Translations text="selection.document_unavailable" backup="No PDF file specified." />}
                            file={document}
                            // file="https://res.cloudinary.com/saiyean/image/upload/v1634214100/V3%20Logo/dummy.pdf"
                            onLoadSuccess={(r) => {
                                // console.log('r->', r);
                                // console.log('r.numPages->', r.numPages);
                                setNumPages(r.numPages);
                            }}
                        >
                            {Array.from(
                                new Array(numPages),
                                (el, index) => (
                                    <Page
                                        key={`page_${index + 1}`}
                                        loading={<Translations text="common.loading" backup="Loading" />}
                                        error={<Translations text="selection.document_load_error" backup="Failed to load PDF file." />}
                                        noData={<Translations text="selection.document_unavailable" backup="No PDF file specified." />}
                                        pageNumber={index + 1}
                                        width={size.width}
                                        scale={zoomScale}
                                    />
                                ),
                            )}
                            {/* <Page
                                pageNumber={pageNumber}
                                width={size.width}
                            /> */}
                        </Document>
                    )}
                </SizeMe>
            </Modal.Content>
            <Modal.Content style={{textAlign: "center"}}>
                <Button
                    secondary
                    icon="zoom-out"
                    content={<Translations text="common.zoom_out" backup={"Zoom Out"} />}
                    onClick={() => setZoomScale(1)}
                />
                <Button
                    primary
                    icon="zoom-in"
                    content={<Translations text="common.zoom_in" backup={"Zoom In"} />}
                    onClick={() => setZoomScale(zoomScale + 0.5)}
                />
            </Modal.Content>
            {/* <Modal.Content>
                <div style={{fontSize: 10, textAlign: "center",}}>
                    <p>Page {pageNumber} of {numPages}</p>
                    <Button
                        secondary
                        content="Previous Page"
                        style={{marginTop: 10}}
                        disabled={(pageNumber - 1 < 1)}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    />
                    <Button
                        icon="zoom-in"
                        onClick={() => setPageNumber(pageNumber - 1)}
                    />
                    <Button
                        icon="zoom-out"
                        onClick={() => setPageNumber(pageNumber - 1)}
                    />
                    <Button
                        primary
                        content="Next Page"
                        style={{marginTop: 10}}
                        disabled={(pageNumber + 1 > numPages)}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    />
                </div>
            </Modal.Content> */}
        </Modal>
    );
};

export default ModalViewDocument;
